module.exports = __webpack_public_path__ + "static/media/uber-direct.e4c7e287.webp";